import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { returnErrors } from "../actions/errorAction";
import { auctionListFailure, auctionListSuccess } from "../actions/allAuctionListAction";

const getLoginResult = (state) => state.loginReducer.loginResult;

function* asyncFetchAllAuctionListSaga(action){
    try{
        const loginResult = yield select(getLoginResult);
        const accessToken = loginResult?.data?.auth_token?.access_token;
        const user_id = loginResult?.data?.user_id;

        let resAuctionList = yield call(_api.fetchAllAuctionListRequest, {
            user_id: user_id,
            accessToken: accessToken
        })
        yield put(auctionListSuccess({resAuctionList}))
    }catch(e){
        yield put(auctionListFailure({error:e}))
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* fetchAllAuctionListSaga(){
    yield takeLatest(types.FETCH_ALL_AUCTION_LIST_REQUEST,asyncFetchAllAuctionListSaga)
}
